module.exports = __webpack_public_path__ + "static/media/Edosa given (1).530ec1c7.jpg";